import * as $ from "jquery"

export class LicensePlate {

    static ResetSpecialLicensePlate() {
        $("#licenseplatestatus").val("isNormal");
        $("#div-speciallicenseplate").hide();
        document.getElementById("check-speciallicenseplate")?.removeAttribute("required");
        $("#check-speciallicenseplate").prop("checked", false);
        LicensePlate.ShowInfoText();
        LicensePlate.ShowLicensePlatePlaceHolder();
    }

    static isLicensePlateCountrySet() {
        return $("#licenseplate_country option:selected").length > 0 &&
            $("#licenseplate_country option:selected").val() !== "";
    }

    static ShowInfoText() {
        if (LicensePlate.isLicensePlateCountrySet()) {
            const $selectedCountryOption = $("#licenseplate_country option:selected");
            const helpText = $selectedCountryOption.data("helptext");
            const specialHelpText = $selectedCountryOption.data("specialhelptext");

            //const specialWarning = $selectedCountryOption.data("specialwarning");
            //$("#div-speciallicenseplate-warning b").text(specialWarning); //does not work since there is no <b> tag to set the text
            const specialLabel = $selectedCountryOption.data("speciallabel");
            $("#label-check-speciallicenseplate").text(specialLabel);

            const $checkBox = $("#check-speciallicenseplate");
            if ($checkBox.is(":checked")) {
                $("#div-speciallicenseplate-warning").removeClass("alert-warning").removeClass("alert-warning-hide").removeClass("alert");
                $("#div-speciallicenseplate-header").hide();
            } else {
                $("#div-speciallicenseplate-warning").addClass("alert-warning").addClass("alert-warning-hide").addClass("alert");
                $("#div-speciallicenseplate-header").show();
            }

            if (!$checkBox.is(":checked") && helpText !== "") {
                $("#infotext-licenseplate-text").text(helpText);
                $("#infotext-licenseplate-sr-text").text(helpText);
                $("#infotext-licenseplate").show();
            } else if ($checkBox.is(":checked") && specialHelpText !== "") {
                $("#infotext-licenseplate-text").text(specialHelpText);
                $("#infotext-licenseplate-sr-text").text(specialHelpText);
                $("#infotext-licenseplate").show();

            } else {
                $("#infotext-licenseplate-text").text("");
                $("#infotext-licenseplate-sr-text").text("");
                $("#infotext-licenseplate").hide();
            }
        } else {
            $("#infotext-licenseplate-text").text("");
            $("#infotext-licenseplate-sr-text").text("");
            $("#infotext-licenseplate").hide();
        }
    }

    static ShowLicensePlatePlaceHolder() {
        let placeholder = "";
        if (LicensePlate.isLicensePlateCountrySet()) {
            const SelectedCountryContainer: HTMLSelectElement = <HTMLSelectElement>document.getElementById("licenseplate_country");
            const SelectedCountry = SelectedCountryContainer.item(SelectedCountryContainer.selectedIndex);
            const placeholderText = SelectedCountry.getAttribute("data-placeholdertext");
            const specialPlaceholderText = SelectedCountry.getAttribute("data-specialplaceholdertext");
            const SpecialLicensePlateCheckbox: HTMLInputElement = <HTMLInputElement>document.getElementById("check-speciallicenseplate");
            placeholder = SpecialLicensePlateCheckbox?.checked && specialPlaceholderText !== ""
                ? specialPlaceholderText
                : placeholderText !== ""
                    ? placeholderText
                    : "";
        }
        document.getElementById("licenseplate").setAttribute("placeholder", placeholder);
        document.getElementById("licenseplateconfirm")?.setAttribute("placeholder", placeholder);
    }
}
